import { SATISFACTION_FORM_ANSWERS_SERVICE } from "@/services/satisfactionFormAnswers.service.js";

const state = {
    getSatisfactionFormAnswersOutput: null,
    isLoadingSatisfactionFormAnswers: false
};

const actions = {
    async getSatisfactionFormAnswers({ commit, dispatch }, queryParams) {
        try {
            commit('getSatisfactionFormAnswersRequest');
            const response = await SATISFACTION_FORM_ANSWERS_SERVICE.getSatisfactionFormAnswers(queryParams);
            commit('getSatisfactionFormAnswersSuccess', response);
            return response;
        } catch (error) {
            commit('getSatisfactionFormAnswersFailure');
            await dispatch('alert/error', error, { root: true });
            throw error;
        }
    }
};

const mutations = {
    getSatisfactionFormAnswersRequest(state) {
        state.isLoadingSatisfactionFormAnswers = true;
    },
    getSatisfactionFormAnswersSuccess(state, output) {
        state.getSatisfactionFormAnswersOutput = output;
        state.isLoadingSatisfactionFormAnswers = false;
    },
    getSatisfactionFormAnswersFailure(state) {
        state.isLoadingSatisfactionFormAnswers = false;
        state.getSatisfactionFormAnswersOutput = null;
    }
};

export const satisfactionFormAnswers = {
    namespaced: true,
    state,
    actions,
    mutations
};

